import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import './styles.css';

/**
 * PARIDAD NAVEGADOR-SERVIDOR (DEC-10).
 *
 * En desarrollo y en las pruebas extremo a extremo, la SPA expone el motor de
 * reglas para que Playwright pueda ejecutarlo DENTRO del navegador y comparar
 * sus diagnosticos con los de Node. No se expone en produccion: no aporta nada
 * al cliente y es superficie de mas.
 */
if (import.meta.env.DEV || import.meta.env['VITE_EXPOSE_PARITY'] === 'true') {
  void import('@besbello/rules-core').then((rules) => {
    (window as unknown as { __BESBELLO_PARITY__: unknown }).__BESBELLO_PARITY__ = rules.computeParitySnapshot;
  });
}

const root = document.getElementById('root');
if (!root) throw new Error('falta #root en index.html');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
